export interface Modified {
  by: string;
  on: string;
}
